import { Select } from "@mui/material";
import { styled } from "@mui/material/styles";
import ArrowUpDown from "../assets/image/arrorUpDown.svg";

export const CustomSelect = styled(Select)(({ open }) => ({
  width: "100%",
  height: "35px",
  borderRadius: "4px",
  color: "var(--color-airline-code)",
  borderColor: "var(--Boxider-bg)",
  outline: "none",
  fontSize: "15px",
  fontFamily: "Outfit",
  backgroundColor: "var(--color-bg-white)",

  "&.Mui-focused": {
    backgroundColor: "var(--input-bg-color)",
    outline: "none",
  },
  "& .MuiInputBase-input": {
    fontWeight: 500,
  },
  "& .MuiInputBase-input:focus": {
    fontWeight: 500,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "var(--Boxider-bg)",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "var(--color-primary-light)",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "var(--color-primary-light)",
  },

  "& .MuiSelect-icon": {
    display: "none",
  },
  "&:after": {
    content: `url(${ArrowUpDown})`,
    position: "absolute",
    right: "10px",
    top: "calc(50% - 10px)",
    pointerEvents: "none",
    transform: open ? "rotate(180deg)" : "rotate(0deg)", 
    transition: "transform 0.3s ease",
  },
}));